module.exports = __webpack_public_path__ + "static/MartinBorgelGERMANY-359a5217f28eb0facf9658d4b9b0f81d.jpg";